import { cover } from "polished";
import styled, { css } from "styled-components";
import getBorderColor from "../../../utils/getBorderColor";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import space from "../../../utils/space";
import unit from "../../../utils/unit";
import { LabelWithTooltipContainer } from "../LabelWithTooltipMol";
export var breakpointValue = "medium";
export var Box = styled.div.withConfig({
  componentId: "sc-nemszi-0"
})(function (_ref) {
  var $onColor = _ref.$onColor,
    theme = _ref.theme;
  return css(["display:flex;position:relative;flex-direction:column;align-items:flex-start;padding:", " ", ";border:", " solid ", ";border-radius:", ";box-shadow:", ";&:hover{box-shadow:", ";}"], space(3), space(2.5), unit(1), getBorderColor(theme, $onColor, "extraLow"), getBorderRadius(theme, "xlarge"), getBoxShadow(theme, "tiny"), getBoxShadow(theme, "medium"));
});
export var Content = styled.div.withConfig({
  componentId: "sc-nemszi-1"
})(["width:100%;"]);
export var Title = styled.div.withConfig({
  componentId: "sc-nemszi-2"
})(["margin-top:", ";margin-bottom:", ";> *{color:inherit;text-decoration:none;&::after{", ";content:\"\";}}"], space(1.5), space(1), cover());
export var Description = styled.div.withConfig({
  componentId: "sc-nemszi-3"
})(["min-height:", ";"], space(6));
export var TooltipWrapper = styled.div.withConfig({
  componentId: "sc-nemszi-4"
})(["position:relative;"]);
export var Logo = styled.div.withConfig({
  componentId: "sc-nemszi-5"
})(["height:", ";& img{width:auto;max-height:", ";}"], space(5), space(5));
export var LabelWrapper = styled.div.withConfig({
  componentId: "sc-nemszi-6"
})(["min-height:", ";", "{z-index:1;}"], space(4), LabelWithTooltipContainer);